var exports = {
  "m": "LoadableComponent.module__inline___LVlDRF",
  "p": "LoadableComponent.module__inlineIcon___LVlDRF",
};

module.exports = exports;
